import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Layout from './Layout/Layout';

import { ServerImage } from '../../../server/app';

import SizeStyles from './Size.styles';
import InHand from './Assets/InHand';
import InPocket from './Assets/InPocket';

// Component
const Size: React.FC<RouteComponentProps> = () => {
  // Local state
  const [devices, setDevices] = useState<ServerImage[]>([]);
  const [device, setDevice] = useState<ServerImage | undefined>();
  const [view, setView] = useState<'hand' | 'pocket'>('hand');

  // Effects
  useEffect(() => {
    const getAvailableImages = async () => {
      const availableImages = await axios.get<ServerImage[]>('/api/images?path=devices');
      const sortedImages = availableImages.data.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );

      setDevices(sortedImages);
    };

    getAvailableImages();
  }, []);

  // Render
  return (
    <Layout>
      <SizeStyles>
        <h2>Size</h2>

        <div className="selection">
          <div className="phone">
            <Autocomplete
              disableClearable
              options={devices}
              getOptionLabel={device => device.name}
              onChange={(_e, value) => value && setDevice(value)}
              renderInput={params => <TextField {...params} label="Device" variant="outlined" />}
            />
          </div>

          <div className="view">
            <RadioGroup
              row
              onChange={(_e, value) => (value === 'hand' || value === 'pocket') && setView(value)}
              value={view}
            >
              <FormControlLabel value="hand" control={<Radio />} label="In Hand" />
              <FormControlLabel value="pocket" control={<Radio />} label="In pocket" />
            </RadioGroup>
          </div>
        </div>

        {device && (
          <div className="size">
            {view === 'hand' ? (
              <InHand device={device} />
            ) : view === 'pocket' ? (
              <InPocket device={device} />
            ) : null}
          </div>
        )}
      </SizeStyles>
    </Layout>
  );
};

export default Size;
